module.exports = __webpack_public_path__ + "img/2.1d87d08d.jpg";